/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import classNames from 'classnames';

// Services
import Agreement from 'services/data/agreement';
import Ticket from 'services/data/ticket';

// Actions
import { alerts } from 'modules/alerts/actions';

// Components
import SVG from 'components/widgets/icons/svg';
import { FormError, Form } from 'components/forms/form-structure';
import CompanySelect from 'components/forms/selects/company-select';
import AgreementSelect from 'components/forms/selects/agreement-select';
import TicketSelect from 'components/forms/selects/ticket-select';
import { CheckboxInput } from 'components/forms/form-elements';
import { TicketDescriptionInput } from 'components/forms/help-text';
import { SubmitButton } from 'components/widgets/buttons';

// Helpers
import requiredValidation from 'utils/required-validation';


class AddToTicketForm extends React.Component {
  static propTypes = {
    formValues: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string,
    submitFailed: PropTypes.bool,
    addToTicket: PropTypes.func.isRequired,
    change: PropTypes.func,
    submitting: PropTypes.bool,
    item: PropTypes.shape({
      setOpen: PropTypes.func
    })
  };

  constructor() {
    super();
    this.state = { openTickets: [] };
    this.findOpenTickets = this.findOpenTickets.bind(this);
    this.setBillable = this.setBillable.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const nextAgreement = nextProps.formValues.agreement;
    const agreement = this.props.formValues.agreement;

    if (agreement !== nextAgreement) this.findOpenTickets(nextAgreement);
  }

  setBillable(agreement) {
    this.props.change('timeDefaultBillable', agreement && agreement.timeDefaultBillable);
  }

  findOpenTickets(agreement) {
    if (!agreement) return Promise.resolve();

    Ticket.find({
      where: { agreement, status: 'Active' },
      sort: 'nextTaskDate',
      limit: 5
    })
      .then((openTickets) => {
        this.setState({ openTickets });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { addToTicket, handleSubmit, error, submitFailed, submitting, item: { setOpen } } = this.props;
    const { company, agreement, ticket, description } = this.props.formValues;

    return (
      <div className="triage-add-ticket-form">
        <div className="triage-option-form-header triage-option-header" onClick={() => setOpen(false)}>
          <SVG src="svg/ticket.svg" className="ticket triage-option-icon" />
          <span>Ticket</span>
          <SVG src="svg/close.svg" className="close-triage-submenu" />
        </div>
        <Form className="triage-option-submenu" onSubmit={handleSubmit} customSubmitArea>
          <Field component={CompanySelect} name="company" label="Company" />
          { company &&
            <Field component={AgreementSelect} onChangeFullValue={this.setBillable} name="agreement" label="Agreement" company={company} searchParams={Agreement.activeQuery} />
          }
          { company && agreement &&
            <div>
              <div className={classNames({ 'unnecessary-form-section': description })}>
                <div className="ticket-section-header">Select existing ticket</div>
                {_.map(this.state.openTickets, openTicket =>
                  <div
                    key={openTicket.id}
                    className="open-ticket"
                    onClick={description ? _.noop : () => addToTicket({ ticket: openTicket.id, company }) }
                  >
                    <SVG src="svg/ticket.svg" />
                    <div>{openTicket.description}</div>
                  </div>
                )}
                <Field
                  component={TicketSelect}
                  name="ticket"
                  label="Search for a ticket"
                  agreement={agreement}
                  company={company}
                  disabled={description}
                />
              </div>
              <div className={classNames({ 'unnecessary-form-section': ticket })}>
                <div className="ticket-section-header">Or create new ticket</div>
                <Field component={TicketDescriptionInput} name="description" label="Description" disabled={ticket} />
                <Field component={CheckboxInput} name="timeDefaultBillable" label="Time Reports are Billable by Default" />
              </div>
              <div className="submit-area">
                <SubmitButton showLoading={submitting} />
                <FormError error={error} submitFailed={submitFailed} />
              </div>
            </div>
          }
        </Form>
      </div>
    );
  }
}

const ConnectedComponent = connect((state, ownProps) => ({
  formValues: formValueSelector(ownProps.form)(state, 'company', 'agreement', 'ticket', 'description'),
  companies: state.pageData.selectCompanies
}))(AddToTicketForm);

export default reduxForm({
  validate: (values) => {
    const errors = requiredValidation(['company', 'agreement'], values);
    if (!values.ticket && !values.description) {
      errors._error = 'Choose existing ticket or create new ticket';
    }
    return errors;
  }
})(ConnectedComponent);



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/forms/add-to-ticket-form.js